import React from 'react';
import { openQRCodeModal } from './state';
import QRCodeDisplay from './QRCodeDisplay';
import './QRCodeTrigger.scss';

interface QRCodeTriggerProps {
  customerEmail?: string;
  customerName?: string;
}

const QRCodeTrigger = ({ customerEmail, customerName }: QRCodeTriggerProps) => {
  const handleClick = () => {
    openQRCodeModal({
      customerEmail,
      customerName,
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className="qr-code-trigger qr-trigger-div"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label="Open QR Code"
    >
      <div className="qr-icon">
        <QRCodeDisplay
          email={customerEmail || ''}
          width={80}
          className="qr-trigger-display"
          alt="QR Code"
          showLoading={false}
          showError={false}
        />
      </div>
      <p>Member ID</p>
    </div>
  );
};

export default QRCodeTrigger;
